import { render, staticRenderFns } from "./tiscBurger.vue?vue&type=template&id=d9788cba&scoped=true&"
import script from "./tiscBurger.vue?vue&type=script&lang=js&"
export * from "./tiscBurger.vue?vue&type=script&lang=js&"
import style0 from "./tiscBurger.vue?vue&type=style&index=0&id=d9788cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9788cba",
  null
  
)

export default component.exports